<template>
  <ul>
    <li v-for="(path, id) in images" :key="id" class="m-v0">
      <label class="radio-label">
        <input
          type="radio"
          class="radio"
          :name="inputName"
          :value="id"
          :checked="id === modelValue"
          @change="handleChange"
        >
        <div class="radio-image-wrap">
          <div class="bg-lightest-gray br-8">
            <donut-soft-load-img>
              <cdn-img
                :path="path"
                class="w-100p br-8 d-b"
                :style="{'aspect-ratio': aspectRatio}"
              />
            </donut-soft-load-img>
          </div>
        </div>
      </label>
    </li>
  </ul>
</template>

<script setup>
const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  inputName: {
    type: String,
    required: true,
  },
  images: {
    type: Object,
    required: true,
  },
  aspectRatio: {
    type: [Number, String],
    default: 1,
  },
});

const handleChange = (ev) => {
  emit('update:modelValue', ev.target.value);
};
</script>

<style scoped lang="scss">
@import '../../styles/donut.scss';

.radio {
  width: 0;
  height: 0;

  margin: 0;
  padding: 0;

  border: 0;
  visibility: hidden;

  appearance: none;
  -webkit-appearance: none;

  & + .radio-image-wrap {
    border: 4px solid transparent;
    margin: -4px;
    border-radius: 12px;
    transition: border-color 0.15s;
  }

  &:checked + .radio-image-wrap {
    border-color: $purple;
  }
}

.radio-label {
  display: block;
  padding: 0;
  margin: 0;
}
</style>
